



















































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import AbpBase from "@/lib/abpbase";
import Util from "@/lib/util";
import MenuBottonPO from "@/store/entities/basedata/menupo";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import TreeSelect from "@riophae/vue-treeselect";
@Component({
  components: { TreeSelect },
})
export default class EditMenuButton extends AbpBase {
  @Prop({ type: Boolean, default: false }) value: boolean;
  menubuttonpo: MenuBottonPO = new MenuBottonPO();
  loading: boolean = false;
  created() {
    this.menubuttonpo.isEnable = 1;
  }
  create() {
    //console.log(this.list);
  }
  save() {
    (this.$refs.areaForm as any).validate(async (valid: boolean) => {
      if (valid) {
        this.loading = true;
        await this.$store
          .dispatch({
            type: "menu/update",
            data: this.menubuttonpo,
          })
          .catch(() => {
            this.loading = false;
          });
        this.loading = false;
        (this.$refs.areaForm as any).resetFields();
        this.$emit("save-success");
        this.$emit("input", false);
      }
    });
  }
  cancel() {
    (this.$refs.areaForm as any).resetFields();
    this.$emit("input", false);
  }
  visibleChange(value: boolean) {
    if (!value) {
      this.$emit("input", value);
    } else {
      this.menubuttonpo = Util.extend(
        true,
        {},
        this.$store.state.menubutton.editMenuButton
      );
    }
  }
  areaRule = {
    tagName: [
      {
        required: true,
        message: this.L("TagCanNotBeEmpty"),
        trigger: "blur",
      },
    ],
    displayName: [
      {
        required: true,
        message: this.L("NameCanNotBeEmpty"),
        trigger: "blur",
      },
    ],
    sortCode: [
      {
        type: "number",
        required: true,
        message: this.L("CanNotBeEmpty"),
        trigger: "blur",
      },
    ],
  };
}
